module.exports = __webpack_public_path__ + "static/media/wordmark-logo.e2a7456b.png";